module.exports = {"callIn":"呼入","callOut":"呼出","incomingCall":"来电","businessAcceptance":"业务受理","tokenOrExtEmpty":"token或者分机为空，电话条无法初始化","httpRequired":"网页电话需使用https访问，请重新登录","phoneBarInitFailed":"电话条初始化失败：","newCallNotify":"您有一个新的来电","eventListenerError":"事件监听异常，异常信息：","smsTitle":"发短信","noSessionForKnow":"没有可引用/发送的会话/当前不处于会话页签","newTicketCallOut":"新工单手机号字段外呼，只弹屏不拨打电话","connected":"接通","notConnected":"未接通","rtcCommunication":"视频客服相关的通信","tokenEmpty":"token为空，电话条无法初始化"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/zh-CN/wincall.json
// module id = 7Xqm
// module chunks = 1